import { USERS_PERMISSIONS } from 'settings';
import {
  pickValue,
  setPickedKeyValue,
} from 'utils/objects';
import { parseIfValid } from './json';

export function encode(permisssions, company = '*') {
  const definition = [];

  Object.entries(permisssions).forEach(([keyApp, valApp]) => {
    Object.entries(valApp).forEach(([keyModule, valModule]) => {
      Object.entries(valModule).forEach(([keyAction, valAction]) => {
        const actions = [];

        Object.keys(valAction).forEach((name) => {
          if (valAction[name]) {
            actions.push(`${keyApp}_${keyModule}_${keyAction}:${name}`);
          }
        });

        if (actions.length > 0) {
          definition.push({
            Action: actions,
            Effect: 'Allow',
            Resource: `dcore:${company}:${keyModule}:*`,
          });
        }
      });
    });
  });

  return definition;
}

export function decode(statements = []) {
  const obj = {};

  statements.forEach((item) => {
    (item.Action || []).forEach((action) => {
      setPickedKeyValue(
        obj,
        action.split(':').join('_'),
        true,
        '_',
      );
    });
  });

  return obj;
}

export function hasPermissions(permission, haveAny = false, app = USERS_PERMISSIONS) {
  // FIXME: Remove when activate user roles
  if (1) {
    return true;
  }

  const permissions = Array.isArray(permission)
    ? permission
    : [permission];

  try {
    const role = parseIfValid(localStorage.getItem('permissions'), false) || [];
    const statements = decode(role);

    if (!!pickValue(statements, '*.*')) {
      return true;
    }

    return permissions
      .map(item => !!pickValue(statements, `${app}.${item}`))[haveAny
        ? 'some'
        : 'every']((item) => item);
  } catch (error) {
    console.error(error.message);

    return false;
  }
};
